import { useEffect, useState } from 'react';
import { TweenMax } from 'gsap';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const [isAddEnergy, setIsAddEnergy] = useState(false);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationD .msg-box1 .msg-title',
            offset: -65, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '20%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: '.animationD .msg-box1 .msg-desc',
            offset: layoutH * 0.1, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '20%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationD .msg-box1 .msg-title',
            0.3,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        const tweenA2 = TweenMax.fromTo(
            '.animationD .msg-box1 .msg-desc',
            0.3,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);
        sceneA2.setTween(tweenA2);
        controllerDelta2?.addScene(sceneA1);
        controllerDelta2?.addScene(sceneA2);
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.animationD .msg-box1 .msg-desc`,
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '0%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setIsAddEnergy(true);
        });
        sceneA1.on('leave', function () {
            setIsAddEnergy(false);
        });

        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationD} animationD GtmModuleData-section`} data-section-id={css.animationD} data-section-title={t('delta2.aniD_box1_msg1')}>
            <div className={`${isAddEnergy ? 'add-energy' : ''} sticky-box`}>
                <div className="msg-box1">
                    <div className="msg-title title-bolder">{t('delta2.aniD_msg1')}</div>
                    <div className="msg-desc">
                        <div className="desc">{t('delta2.aniD_msg2')}</div>
                        <div className="extra">
                            <div className="energy">
                                <div className={`old-energy`}>
                                    <div className="old-energy-in">
                                        <div className="color-text">{t('delta2.aniD_num1')}</div>
                                        <div className="color-text">{t('delta2.aniD_num2')}</div>
                                    </div>
                                </div>
                                <div className="color-text">{t('delta2.aniD_unit')}</div>
                            </div>
                            <div>{isAddEnergy ? t('delta2.aniD_msg4') : t('delta2.aniD_msg3')}</div>
                        </div>
                    </div>
                </div>
                <div className="img-box">
                    <div className="img-1">
                        <EFPic name={['animD1.webp', 'animD1.jpg']} />
                    </div>
                    <div className="img-2">
                        <EFPic name={['animD2.webp', 'animD2.jpg']} />
                    </div>
                    <div className={`${isAddEnergy ? 'product-name2' : ''} product-name`}>
                        <div>{t('delta2.aniD_product1')}</div>
                        <div>{isAddEnergy ? t('delta2.aniD_product3') : t('delta2.aniD_product2')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
